module.exports = __webpack_public_path__ + "static/email/img/icon_template.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_template.png
// module id = xcFW
// module chunks = 1